import { InventoryDTO } from "../DTO/inventoryDTO";
import { BasicResponse } from "./basicResponse";

export class InventoryResponse extends BasicResponse{
    public inventory:Array<InventoryDTO> = [];

    constructor(){
        super();
    }
}